<template>
  <div>
    <div class="content">
      <div class="title-select" v-if="robotList.length > 1">
        <el-select
          v-model="currentTicket"
          placeholder="请选择"
          size="medium"
          @change="robotChange"
        >
          <el-option
            v-for="item in robotList"
            :key="item.ticket"
            :label="
              `${item.label}${item.huyaUserName ? `-${item.huyaUserName}` : ''}`
            "
            :value="item.ticket"
          ></el-option>
        </el-select>
      </div>
      <div class="block" v-for="(item, index) in tableData" :key="index">
        <div v-if="item.dataType == 1">
          <div class="fn-item">
            <em
              :class="{
                red: item.timeRemaining < 3,
              }"
              >{{
                item.timeRemaining > 0
                  ? "剩余" + item.timeRemaining + "天"
                  : "已过期"
              }}</em
            >
            <el-checkbox
              class="checked"
              @change="item.timeRemaining <= 0 ? clickBaseCheckTips(item) : ''"
              v-model="item.checked"
              >{{ item.name }}</el-checkbox
            >
            <small
              >￥{{ item.products[timeAdd].price / 100 }}/{{
                timeOptions[timeAdd]
              }}</small
            >
          </div>
          <div class="desc">
            <ul>
              <li>来宾欢迎</li>
              <li>礼物答谢</li>
              <li>定时引导</li>
              <li>智能答复</li>
              <li>AI互动</li>
              <li>语音播报</li>
              <li>自动封禁</li>
              <li>大哥名单</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="block" v-if="tableData.length > 1">
        <div class="fn-item">
          <el-checkbox
            class="checked"
            :indeterminate="isIndeterminate"
            v-model="tabledataOf2AllChecked"
            >增值功能</el-checkbox
          >
          <small>￥{{ tabledataOf2Price }}/{{ timeOptions[timeAdd] }}</small>
        </div>
        <div v-for="(item, index) in tableData" :key="index">
          <div class="fn-item-sub" v-if="item.dataType == 2">
            <em
              :class="{
                red: item.timeRemaining < 3,
              }"
              >{{
                item.timeRemaining > 0
                  ? "剩余" + item.timeRemaining + "天"
                  : "已过期"
              }}</em
            >
            <el-checkbox class="checked" v-model="item.checked">{{
              item.name
            }}</el-checkbox>
            <small
              >￥{{ item.products[timeAdd].price / 100 }}/{{
                timeOptions[timeAdd]
              }}</small
            >
          </div>
        </div>
      </div>
      <div class="title-line" v-if="recommendListCurrent">
        <span class="gray">您可能还需要</span>
      </div>
      <div class="block" v-if="recommendListCurrent">
        <div class="fn-item">
          <el-link
            type="primary"
            @click="toggleRecommend"
            v-if="recommendListTableData.length > 1"
            >换一个></el-link
          >
          <el-checkbox class="checked" v-model="recommendListCurrent.checked">{{
            recommendListCurrent.name
          }}</el-checkbox>
          <small
            >￥{{ recommendListCurrent.products[timeAdd].price / 100 }}/{{
              timeOptions[timeAdd]
            }}</small
          >
        </div>
        <div class="desc">{{ recommendListCurrent.desc }}</div>
      </div>
    </div>

    <div class="check-out">
      <button class="button" @click="totalRenew">续费</button>
      <el-select
        class="time-add"
        ref="timeAddSelect"
        v-model="timeAdd"
        placeholder="请选择"
        size="mini"
        @focus="inputFocus"
        @blur="inputBlur"
        @visible-change="inputVisibleChange"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <p>
        总计：￥{{ totalPrice }}
        <span v-show="totalPrice >= 89 && totalPrice <= 358"
          >（花呗分期免息）</span
        >
      </p>
    </div>
  </div>
</template>

<script>
import { getOrderPags, getFeatureProducts } from "@/api/index";
import { mapState } from "vuex";
let recommendList = [
  "cloud_in",
  "beggift",
  "guessnum",
  "guessProvince",
  "duty",
];
let featureDesc = {
  cloud_in: "让小虎弟帮您挂机器人，开播自动进场",
  beggift: "让机器人学会狗礼物，智能选择时机和对象",
  guessnum: "1~100猜点数，5分钟一局。弹幕互动小游戏",
  guessProvince: "全国猜省会，10分钟一局。弹幕互动小游戏",
  duty: "让机器人下播后也工作，持续导量到微博等",
};
let featureName = {
  cloud_in: "升级 云端挂机",
  beggift: "升级 狗礼物",
  guessnum: "升级 猜点数",
  guessProvince: "升级 猜省会",
  duty: "升级 下播值守",
};
export default {
  data() {
    return {
      currentTicket: "",
      tableData: [],
      recommendListTableData: [],
      recommendListCurrent: null,
      recommendListCurrentIndex: 0,
      tabledataOf2AllChecked: true, //增值功能续费全选按钮
      isIndeterminate: false,
      timeAdd: 0,
      options: [
        {
          value: 0,
          label: "月卡（30天）",
        },
        {
          value: 1,
          label: "季卡（90天 +送30天）",
        },
        {
          value: 2,
          label: "年卡（365天 +送120天）",
        },
        {
          value: 3,
          label: "周卡（7天）",
        },
      ],
      timeOptions: ["月", "季", "年", "周"],
    };
  },
  props: {
    robotList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ticket: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState({
      guideType: (state) => state.guideType,
    }),
    tabledataOf2Price() {
      let totalPrice = 0;
      this.tableData.forEach((subval, index) => {
        if (subval.dataType == 2 && subval.checked) {
          totalPrice += subval.products[this.timeAdd].price;
        }
      });
      return totalPrice / 100;
    },
    totalPrice() {
      let totalPrice = 0;
      this.tableData.forEach((subval, index) => {
        if (subval.checked) {
          totalPrice += subval.products[this.timeAdd].price;
        }
      });
      this.recommendListTableData.forEach((subval, index) => {
        if (subval.checked) {
          totalPrice += subval.products[this.timeAdd].price;
        }
      });
      return totalPrice / 100;
    },
  },
  watch: {
    tabledataOf2AllChecked(val) {
      if (val) {
        this.tableData.forEach((subval, index) => {
          if (subval.dataType == 2) {
            this.tableData[index].checked = val;
          }
        });
      } else {
        let count = 0;
        this.tableData.forEach((subval, index) => {
          if (subval.checked && subval.dataType == 2) {
            count++;
          }
        });
        if (count == this.tableData.length - 1) {
          this.tableData.forEach((subval, index) => {
            if (subval.dataType == 2) {
              this.tableData[index].checked = val;
            }
          });
        }
      }
    },
    tableData: {
      handler: function(val, oldVal) {
        let count = 0;
        val.forEach((val) => {
          if (val.checked && val.dataType == 2) {
            count++;
          }
        });
        if (count === val.length - 1) {
          this.tabledataOf2AllChecked = true;
          this.isIndeterminate = false;
        } else {
          this.tabledataOf2AllChecked = false;
          if (count > 0) {
            this.isIndeterminate = true;
          } else {
            this.isIndeterminate = false;
          }
        }
      },
      deep: true,
    },
    ticket(val) {
      console.log(val);
      this.currentTicket = val;
      if (this.ticket) {
        this.getOrderPags();
      }
    },
  },
  mounted() {
    if (this.ticket) {
      this.currentTicket = this.ticket;
      this.getOrderPags();
    }
  },
  methods: {
    toggleRecommend() {
      this.recommendListCurrent.checked = false;
      this.recommendListCurrent = this.recommendListTableData[
        ++this.recommendListCurrentIndex % this.recommendListTableData.length
      ];
    },
    getOrderPags() {
      getOrderPags(
        {
          ticket: this.ticket,
        },
        { notify: false }
      ).then((res) => {
        if (res.code === 0) {
          let recommendList = [
            "cloud_in",
            "beggift",
            "guessnum",
            "guessProvince",
            "duty",
          ];
          let data = res.data.pags;
          this.tableData = [];
          if (data.length) {
            data.forEach((val, index) => {
              let timeRemaining = Math.ceil(
                (val.endTime * 1000 - +new Date()) / 86400000
              );
              let options = [];
              val.products.forEach((val, index) => {
                options.push({
                  value: `${index}`,
                  label: val.name,
                });
              });
              val.products.sort((a, b) => {
                return a.validDuration - b.validDuration;
              });
              val.products.push(...val.products.splice(0, 1));
              if (val.features.length > 1) {
                this.tableData.push({
                  dataType: 1,
                  name: "基础功能",
                  timeRemaining: timeRemaining,
                  timeAdd: "0",
                  products: val.products,
                  checked: val.paid == 1 ? true : false,
                  options: options,
                });
              } else {
                if (val.features[0].name !== "大数据") {
                  this.tableData.push({
                    dataType: 2,
                    name: val.features[0].name,
                    timeRemaining: timeRemaining,
                    timeAdd: "0",
                    products: val.products,
                    checked: val.paid == 1 ? true : false,
                    options: options,
                  });
                }
              }
              if (!!~recommendList.indexOf(val.features[0].productKey)) {
                recommendList.splice(
                  recommendList.indexOf(val.features[0].productKey),
                  1
                );
              }
            });
          }
          this.recommendListTableData = [];
          let getProductsList = [];
          recommendList.forEach((val, index) => {
            getProductsList.push(
              new Promise((resolve, reject) => {
                resolve(this.getFeatureProducts(val, index));
              })
            );
          });
          Promise.all(getProductsList)
            .then((result) => {
              this.recommendListCurrent = null;
              this.recommendListCurrentIndex = 0;
              if (this.recommendListTableData.length) {
                this.recommendListTableData.sort((a, b) => {
                  return a.index - b.index;
                });
                this.recommendListCurrent = this.recommendListTableData[
                  this.recommendListCurrentIndex
                ];
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    getFeatureProducts(val, index) {
      return getFeatureProducts({ productKey: val }).then((res) => {
        if (res.code === 0) {
          res.data.products.sort((a, b) => {
            return a.validDuration - b.validDuration;
          });
          res.data.products.push(...res.data.products.splice(0, 1));
          this.recommendListTableData.push({
            name: featureName[val],
            desc: featureDesc[val],
            products: res.data.products,
            checked: false,
            index,
          });
        }
      });
    },
    robotChange(val) {
      this.$emit("robotChange", val);
    },
    totalRenew() {
      let renewPkey = [];
      let renewPrice = 0;
      let productsName = "";
      this.tableData.forEach((val) => {
        if (val.checked) {
          renewPkey.push(val.products[this.timeAdd].pkey);
          productsName = val.name;
          renewPrice += Number(
            (val.products[this.timeAdd].price / 100).toFixed(1)
          );
        }
      });
      this.recommendListTableData.forEach((val) => {
        if (val.checked) {
          renewPkey.push(val.products[this.timeAdd].pkey);
          productsName = val.name;
          renewPrice += Number(
            (val.products[this.timeAdd].price / 100).toFixed(1)
          );
        }
      });
      if (!renewPkey.length) {
        this.$message.warning("请选择需要续费的功能");
        return;
      }

      this.$emit("orderPayShow", {
        pkey: renewPkey.length == 1 ? renewPkey[0] : renewPkey,
        num: 1,
        channel: "wx",
        type: 1,
        email: "",
        ticket: this.ticket,
        price: renewPrice.toFixed(1),
        productName: `续费`,
        isRenew: true,
      });
    },
    inputFocus() {
      //滚动到顶部
      window.scrollTo(0, 0);
    },
    inputBlur() {
      document.body.scrollTop = 0;
    },
    inputVisibleChange(val) {
      if (!val) {
        this.$refs.timeAddSelect.blur();
      }
    },
    clickBaseCheckTips(item) {
      this.$message({
        dangerouslyUseHTMLString: true,
        type: "error",
        message: "<p>机器人的基础功能必须要续费后才能工作。</p>",
      });
      item.checked = true;
    },
  },
};
</script>
